import { environment } from '../../../environments/environment';

export const applicationRemotes = {
  mfs: environment.mfsControllerUiUrl,
  'id-repository': environment.idRepositoryUiUrl,
  mft: environment.mftUiUrl,
};
